import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const QnA002 = ({ isOpened, onChangeOpenedFlag }) => {
    const { t } = useTranslation();

    useEffect(() => {
        let content = document.getElementById("qna02");

        if (isOpened) {
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = null;
        }
    }, [isOpened]);

    return (
        <div className="accordion">
            <div className="accordion-title" onClick={() => onChangeOpenedFlag(1)}>
                <span className="hiclasstv-deepDarkgrey-text button">
                    <b>2. {t("FAQ_질문_2", { ns: "info" })}</b>
                </span>
            </div>
            <div className="accordion-content hiclasstv-darkgrey-text" id="qna02">
                <span className="d-flex" style={{ minWidth: 'max-content' }}>A.&nbsp;</span>
                <p>
                    {t("FAQ_공통_답변_감사", { ns: "info" })}<br />
                    {t("FAQ_질문_2_답변_1", { ns: "info" })}<br />
                    <b>ㆍPentalk OnChat</b><br />
                    {t("FAQ_질문_2_답변_2", { ns: "info" })}<br />
                    <b>ㆍPencam OnAir</b><br />
                    {t("FAQ_질문_2_답변_3", { ns: "info" })}<br />
                    <b>ㆍHiClass OnBoard</b><br />
                    {t("FAQ_질문_2_답변_4", { ns: "info" })}<br />
                    <b>ㆍ{t("FAQ_질문_2_답변_5", { ns: "info" })}</b><br />
                    {t("FAQ_질문_2_답변_6", { ns: "info" })}
                </p>
            </div>
        </div>
    );
}

export default QnA002;